import React from 'react';
import { IconProps } from '.';

const SvgCircleWonFillRounded = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} d='m14.602 12.418-.394 1.228-.328-1.228h.722ZM9.889 12.418l-.396 1.227-.328-1.227h.724Z' />
      <path
        fill={color}
        fillRule='evenodd'
        d='M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM8.01 8.105a.75.75 0 0 0-1.448.39l.649 2.423H6a.75.75 0 0 0 0 1.5h1.612l1.004 3.748c.22.818 1.37.847 1.63.04l1.218-3.788h.862l1.004 3.748c.22.819 1.371.847 1.63.04l1.219-3.788H18a.75.75 0 0 0 0-1.5h-1.339l.768-2.389A.75.75 0 0 0 16 8.07l-.915 2.848h-1.608l-.665-2.484-.051-.145c-.309-.674-1.336-.652-1.58.105l-.81 2.524H8.763L8.01 8.105Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgCircleWonFillRounded;
